module.exports = __webpack_public_path__ + "static/keyPoints-en-4937ea4d68d533dc6f0d2e94ff8ec0dc.png";